import React from 'react';
import { PageBuilder } from '../../components/global/PageBuilder';
import { SEO } from '../../components/global/SEO';
import ListCrossSells from './ListCrossSells';

const CrossSells = () => (
  <PageBuilder>
    <SEO title="Cross-sells | Blueprint" />
    <div className="a-view up-sells">
      <div className="container">
        <ListCrossSells />
      </div>
    </div>
  </PageBuilder>
);

export default CrossSells;
